import styled from 'styled-components'

export const JobListCard = styled.div`
  .title {
    font-size: 24px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ff7400;
    position: relative;
  }

  .top {
    padding-bottom: 16px;
    border-bottom: 1px solid #ffe8d0;
    margin-bottom: 16px;

    .list-tag {
      margin-top: 20px;
      margin-bottom: 20px;

      svg {
        margin-right: 9px;
        position: relative;
        top: 1px;
        font-size: 18px;
      }

      img {
        margin-right: 10px;
      }
    }
  }
  .apply-button {
    border-radius: 22.5px;
    background: linear-gradient(to left, #ff9700, #ff7400);
    padding: 13px 46px;
    width: 100%;
    display: flex;
    justify-content: space-around;
    font-size: 14px;
    color: white;
    outline: none;
    border: unset;
    align-items: center;
    color: #ffffff;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    margin-bottom: 10px;
    text-align: center;
    text-decoration: none;
  }

  .detail-button {
    border-radius: 22.5px;
    background: #fff;
    padding: 13px 46px;
    width: 100%;
    display: flex;
    justify-content: space-around;
    font-size: 14px;
    color: white;
    outline: none;
    border: unset;
    align-items: center;
    color: #ff7400;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    text-align: center;
    text-decoration: none;
  }
`

export const Menu = styled.div`
  display: flex;
  flex-direction: row;
  button {
    border-radius: 6px;
    background: #fff;
    padding: 13px 46px;
    margin-right: 10px;
    display: flex;
    justify-content: space-around;
    font-size: 14px;
    color: white;
    outline: none;
    border: unset;
    align-items: center;
    color: #ff7400;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    margin-bottom: 32px;
    text-align: center;
    border: 1px solid #ff7400;
    text-decoration: none;
    transition: ease-in-out 0.3s;
    &.active {
      background: linear-gradient(to left, #ff9700, #ff7400);
      color: #ffffff;
    }

    &:hover {
      background: linear-gradient(to left, #ff9700, #ff7400);
      color: #ffffff;
    }
  }
`

export const JobListStyle = styled.div`
  .job-tag-wrapper {
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
  }

  .title {
    svg {
      display: none;
    }
  }

  .responsive-accordion {
    margin-top: 20px;
  }

  @media screen and (min-width: 300px) and (max-width: 1023px) {
    .main-job-list-wrapper {
      padding-top: 50px !important;
    }

    @media screen and (max-width: 576px) {
      .title {
        font-size: 20px;

        svg {
          position: absolute;
          right: 0;
          top: 6px;
          transition: east-in-out 0.3s;
          display: block;

          &.active-job-listing {
            transform: rotate(180deg);
          }
        }
      }

      .responsive-accordion {
        display: none;

        &.active-responsive-accordion {
          display: block;
        }
      }
    }
  }
`
